import React, { useState, useEffect } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import dp from '../../assets/images/i.png'
import { BsPersonLinesFill, BsPersonBadge } from 'react-icons/bs'
import { FaUsers } from 'react-icons/fa'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link, useNavigate, useParams } from 'react-router-dom'

export const AdminRequest = () => {
  toast.configure()
  const navigate = useNavigate()
  const params = useParams()
  const [data, setData] = useState([])
  const [reason, setReason] = useState('')
  const [onHoldreason, setOnHoldReason] = useState('')
  const [rejected, setRejected] = useState(false)
  const [onHold, setOnHold] = useState(false)
  const [value, setValue] = useState('')
  const username = localStorage.getItem('user')
  const today = new Date()

  const getData = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'admin-approval/getApprovedRequestById', {
        id: params.id,
      })
      .then((res) => {
        setData(res.data.data[0])
        setValue(res.data.data[0].final_status)
        if (
          res.data.data[0].admin_reason_reject !== '' &&
          res.data.data[0].final_status === 'Rejected'
        ) {
          setRejected(true)
          setReason(res.data.data[0].admin_reason_reject)
        }
        if (
          res.data.data[0].admin_reason_onhold !== '' &&
          res.data.data[0].final_status === 'On Hold'
        ) {
          setOnHold(true)
          setOnHoldReason(res.data.data[0].admin_reason_onhold)
        }
      })
      .catch((err) => {})
  }
  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const updateStatus = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'admin-approval/updateStatus', {
        status: value,
        id: params.id,
        approved_by: username,
        approved_date: today,
        payee_name: data.payee_name,
        email: data.email,
        reason_of_reject: reason,
        reason_of_onhold: onHoldreason,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          navigate('/billhistory')
        }, 2000)
      })
      .catch((err) => {})
  }
  const paymentDoneStatus = async (status) => {
    await axios
      .post(Baseurl.nodeLocal + 'admin-approval/updateStatus', {
        status: status,
        id: params.id,
        approved_by: username,
        approved_date: today,
        payee_name: data.payee_name,
        email: data.email,
        reason_of_reject: reason,
        reason_of_onhold: onHoldreason,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          navigate('/billhistory')
        }, 2000)
      })
      .catch((err) => {})
  }

  return (
    <div className="adminRequest row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="adminRequestContainer col-md-10">
        {/* breadcrumbs */}

        <div className="divCard d-flex justify-content-center align-items-start flex-column ">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb p-3">
              <li className="breadcrumb-item">
                <Link to="/admindashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/billhistory" className="link text-primary">
                  Latest Request
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {data.payee_name}
              </li>
            </ol>
          </nav>
          {data ? (
            <div className="row w-100">
              <div
                className="col-md-4 d-flex justify-content-center align-items-center flex-column"
                style={{ height: '27rem' }}
              >
                <div className="card p-3 d-flex justify-content-center align-items-center flex-column w-100">
                  <div
                    className="rounded-circle d-flex justify-content-center"
                    style={{ width: '120px', border: '3px solid #124577' }}
                  >
                    <img
                      src={dp}
                      alt="Admin"
                      height={100}
                      className="rounded-circle"
                    />
                  </div>
                  <div class="card-body d-flex justify-content-center flex-column align-items-center">
                    <h5 class="card-title text-primary">{data.payee_name}</h5>
                    <p class="card-text">{data.email}</p>
                  </div>
                </div>
                <div className="card mt-3" style={{ width: '19rem' }}>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item row d-flex">
                      <div className="col-md d-flex align-items-center">
                        <BsPersonBadge />
                        <span
                          className="mb-0 mx-1"
                          style={{ fontSize: '13px', fontWeight: 600 }}
                        >
                          Employee ID
                        </span>
                      </div>
                      <span
                        className="text-secondary col-md  d-flex justify-content-end "
                        style={{ fontSize: '14px' }}
                      >
                        {data.desig_id}
                      </span>
                    </li>
                    <li className="list-group-item row d-flex">
                      <div className="col-md d-flex align-items-center">
                        <BsPersonLinesFill />
                        <span
                          className="mb-0 mx-1"
                          style={{ fontSize: '13px', fontWeight: 600 }}
                        >
                          Department
                        </span>
                      </div>
                      <span
                        className="text-secondary col-md  d-flex justify-content-end"
                        style={{ fontSize: '14px' }}
                      >
                        {data.dept_name}
                      </span>
                    </li>

                    <li className="list-group-item row d-flex">
                      <div className="col-md  d-flex align-items-center">
                        <FaUsers />
                        <span
                          className="mb-0 mx-1"
                          style={{ fontSize: '13px', fontWeight: 600 }}
                        >
                          Manager
                        </span>
                      </div>
                      <span
                        className="text-secondary col-md  d-flex justify-content-end"
                        style={{ fontSize: '14px' }}
                      >
                        {data.manager_name}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-8">
                <div className="card p-3">
                  <h5 className="text-primary mb-3">Payment Details</h5>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Initiated Date</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {moment(data.initiate_date).format('DD-MM-YYYY')}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Expense Date</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {moment(data.date_of_expense).format('DD-MM-YYYY')}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Paid Amount</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {' '}
                        ₹ {data.paid_amount}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Payment Mode</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {' '}
                        {data.mode_name}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Purpose Of Expenditure</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {' '}
                        {data.purpose_of_expenditure}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Expenditure Category</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {data.expenditure_category}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card p-4">
                  <div className="row">
                    <div className="col-md">
                      <h6>HR Status</h6>
                      <p>{data.status}</p>
                    </div>
                    <div className="col-md">
                      <h6>Last Updated By</h6>
                      <p>{data.hr_approved_by}</p>
                    </div>
                    <div className="col-md">
                      <h6>Last Updated Date</h6>
                      <p>
                        {moment(data.hr_approved_dates).format('DD-MM-YYYY')}
                      </p>
                    </div>
                  </div>
                  {data.status === 'Rejected' ? (
                    <>
                      <hr />
                      <div className="row">
                        <h6 className="col-sm-4">Reason</h6>
                        <p className="col-sm-8">{data.hr_reason_reject}</p>
                      </div>
                    </>
                  ) : data.status === 'On Hold' ? (
                    <>
                      <hr />
                      <div className="row">
                        <h6 className="col-sm-4">Reason</h6>
                        <p className="col-sm-8">{data.hr_reason_onhold}</p>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </div>
                <div className="card p-4">
                  <h6 className="text-primary">Actions</h6>
                  <hr className="mt-0" />
                  <div className="row pt-1">
                    {value ? (
                      <div className="mb-3 col-md-6">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          <h6>Update Status</h6>
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          defaultValue={value}
                          name="value"
                          onChange={(e) => {
                            setValue(e.target.value)
                            if (e.target.value === 'Rejected') {
                              setOnHold(false)
                              setRejected(true)
                            } else if (e.target.value === 'On Hold') {
                              setRejected(false)
                              setOnHold(true)
                            } else {
                              setRejected(false)
                              setOnHold(false)
                            }
                          }}
                          required
                        >
                          <option selected value="Pending" disabled>
                            Select
                          </option>
                          <option value="Approved">Approve</option>
                          <option value="On Hold">On Hold</option>
                          <option value="Rejected">Reject</option>
                        </select>
                      </div>
                    ) : (
                      ''
                    )}
                    {rejected ? (
                      <div>
                        <div className="mb-3 col-md-6">
                          <textarea
                            className="form-control"
                            placeholder="Reason"
                            name="reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    ) : onHold ? (
                      <div>
                        <div className="col-md-6 mb-3">
                          <textarea
                            className="form-control"
                            placeholder="Reason"
                            name="onhold"
                            value={onHoldreason}
                            onChange={(e) => setOnHoldReason(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div class="d-grid gap-2 d-md-block">
                      <a href={data.invoice} target="_blank" rel="noreferrer">
                        <button
                          className="btn btn-outline-primary"
                          type="button"
                        >
                          View Invoice
                        </button>
                      </a>

                      <button
                        className={
                          data.final_status === value
                            ? 'btn btn-primary disabled mx-2'
                            : 'btn btn-primary mx-2'
                        }
                        type="submit"
                        onClick={() => {
                          updateStatus()
                        }}
                      >
                        Update
                      </button>

                      <button
                        className={
                          data.final_status === 'Approved'
                            ? 'btn  btn-outline-success'
                            : 'btn  btn-outline-success disabled'
                        }
                        type="button"
                        onClick={() => paymentDoneStatus('Payment Done')}
                      >
                        Payment Done
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <h6>Something went wrong!</h6>
          )}
        </div>
      </div>
    </div>
  )
}
